export const SUBMIT_BOARDCAST_LOADING = "SUBMIT_BOARDCAST_LOADING"
export const UPDATE_BOARDCAST = "UPDATE_BOARDCAST"
export const CLEAR_BOARDCAST = "CLEAR_BOARDCAST"
export const UPDATE_IMPORT_DATA = "UPDATE_IMPORT_DATA"
export const UPDATE_HEADER = "UPDATE_HEADER"
export const UPDATE_BODY = "UPDATE_BODY"